const SupersetLogoHeader = () => {
  return (
    <div className="bg-indigo-600 h-[63px] flex items-center">
      <div className="flex flex-col px-2">
        <h1 className="font-bold leading-7 text-white text-3xl tracking-tight">
          Superset
        </h1>
        <span className="font-normal text-sm tracking-[0.9px] text-white">
          Workout Tracker
        </span>
      </div>
    </div>
  );
};

export default SupersetLogoHeader;
